module.exports = __webpack_public_path__ + "img/corner-joint-right-internal.cf40138e.svg";